function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _headers, _reportError;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var fetchWithNetworkError = require('@uppy/utils/lib/fetchWithNetworkError');

var NetworkError = require('@uppy/utils/lib/NetworkError');

function fetchJSON() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return fetchWithNetworkError.apply(void 0, args).then(function (response) {
    if (response.status === 429) {
      // If the server asks the client to rate limit, reschedule the request 2s later.
      // TODO: there are several instances of rate limiting accross the code base, having one global one could be useful.
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          return fetchJSON.apply(void 0, args).then(resolve, reject);
        }, 2000);
      });
    }

    if (!response.ok) {
      return Promise.reject(new NetworkError(response.statusText));
    }

    return response.json();
  });
}
/**
 * A Barebones HTTP API client for Transloadit.
 */


module.exports = (_headers = /*#__PURE__*/_classPrivateFieldLooseKey("headers"), _reportError = /*#__PURE__*/_classPrivateFieldLooseKey("reportError"), /*#__PURE__*/function () {
  function Client(_opts) {
    var _this = this;

    _classCallCheck(this, Client);

    if (_opts === void 0) {
      _opts = {};
    }

    Object.defineProperty(this, _headers, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _reportError, {
      writable: true,
      value: function value(err, params) {
        if (_this.opts.errorReporting === false) {
          throw err;
        }

        var opts = {
          type: params.type
        };

        if (params.assembly) {
          opts.assembly = params.assembly.assembly_id;
          opts.instance = params.assembly.instance;
        }

        if (params.url) {
          opts.endpoint = params.url;
        }

        _this.submitError(err, opts).catch(function () {// not much we can do then is there
        });

        throw err;
      }
    });
    this.opts = _opts;

    if (this.opts.client != null) {
      _classPrivateFieldLooseBase(this, _headers)[_headers]['Transloadit-Client'] = this.opts.client;
    }
  }
  /**
   * Create a new assembly.
   *
   * @param {object} options
   * @param {string|object} options.params
   * @param {object} options.fields
   * @param {string} options.signature
   * @param {number} options.expectedFiles
   */


  _createClass(Client, [{
    key: "createAssembly",
    value: function createAssembly(_ref) {
      var _this2 = this;

      var params = _ref.params,
          fields = _ref.fields,
          signature = _ref.signature,
          expectedFiles = _ref.expectedFiles;
      var data = new FormData();
      data.append('params', typeof params === 'string' ? params : JSON.stringify(params));

      if (signature) {
        data.append('signature', signature);
      }

      Object.keys(fields).forEach(function (key) {
        data.append(key, fields[key]);
      });
      data.append('num_expected_upload_files', expectedFiles);
      var url = new URL('/assemblies', "".concat(this.opts.service)).href;
      return fetchJSON(url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers],
        body: data
      }).then(function (assembly) {
        if (assembly.error) {
          var error = new Error(assembly.error);
          error.details = assembly.message;
          error.assembly = assembly;

          if (assembly.assembly_id) {
            error.details += " Assembly ID: ".concat(assembly.assembly_id);
          }

          throw error;
        }

        return assembly;
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this2, _reportError)[_reportError](err, {
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Reserve resources for a file in an Assembly. Then addFile can be used later.
     *
     * @param {object} assembly
     * @param {UppyFile} file
     */

  }, {
    key: "reserveFile",
    value: function reserveFile(assembly, file) {
      var _this3 = this;

      var size = encodeURIComponent(file.size);
      var url = "".concat(assembly.assembly_ssl_url, "/reserve_file?size=").concat(size);
      return fetchJSON(url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this3, _reportError)[_reportError](err, {
          assembly: assembly,
          file: file,
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Import a remote file to an Assembly.
     *
     * @param {object} assembly
     * @param {UppyFile} file
     */

  }, {
    key: "addFile",
    value: function addFile(assembly, file) {
      var _this4 = this;

      if (!file.uploadURL) {
        return Promise.reject(new Error('File does not have an `uploadURL`.'));
      }

      var size = encodeURIComponent(file.size);
      var uploadUrl = encodeURIComponent(file.uploadURL);
      var filename = encodeURIComponent(file.name);
      var fieldname = 'file';
      var qs = "size=".concat(size, "&filename=").concat(filename, "&fieldname=").concat(fieldname, "&s3Url=").concat(uploadUrl);
      var url = "".concat(assembly.assembly_ssl_url, "/add_file?").concat(qs);
      return fetchJSON(url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this4, _reportError)[_reportError](err, {
          assembly: assembly,
          file: file,
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Cancel a running Assembly.
     *
     * @param {object} assembly
     */

  }, {
    key: "cancelAssembly",
    value: function cancelAssembly(assembly) {
      var _this5 = this;

      var url = assembly.assembly_ssl_url;
      return fetchJSON(url, {
        method: 'delete',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this5, _reportError)[_reportError](err, {
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Get the current status for an assembly.
     *
     * @param {string} url The status endpoint of the assembly.
     */

  }, {
    key: "getAssemblyStatus",
    value: function getAssemblyStatus(url) {
      var _this6 = this;

      return fetchJSON(url, {
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this6, _reportError)[_reportError](err, {
          url: url,
          type: 'STATUS_ERROR'
        });
      });
    }
  }, {
    key: "submitError",
    value: function submitError(err, _temp) {
      var _ref2 = _temp === void 0 ? {} : _temp,
          endpoint = _ref2.endpoint,
          instance = _ref2.instance,
          assembly = _ref2.assembly;

      var message = err.details ? "".concat(err.message, " (").concat(err.details, ")") : err.message;
      return fetchJSON('https://transloaditstatus.com/client_error', {
        method: 'post',
        body: JSON.stringify({
          endpoint: endpoint,
          instance: instance,
          assembly_id: assembly,
          agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
          client: this.opts.client,
          error: message
        })
      });
    }
  }]);

  return Client;
}());